<template>
  <a
    :href="url"
    aria-label="Visit the authors' web page - opens in new tab"
    rel="external"
    target="_blank"
  >
    <i class="icon">
      <Icon name="fa6-solid:link" />
    </i>
    <span> Visit website </span>
  </a>
</template>

<script lang="ts" setup>
defineProps<{ url: string }>()
</script>

<style lang="less" scoped>
a {
  color: inherit;
}
</style>
